window.addEventListener('load', function () {
  const element = document.querySelector('main')
  if (!element || !element.classList.contains('shop')) return

  const shopItems = document.querySelectorAll('.shop_list > li')

  shopItems.forEach((item) => {
    item.addEventListener('click', function () {
      this.classList.toggle('is-current')
    })
  })

  const offset = 150
  const areas = document.querySelectorAll('area[href^="#open"]')

  areas.forEach((area) => {
    area.addEventListener('click', (e) => {
      e.preventDefault() // ← ここで確実にURL書き換えを防止

      const href = area.getAttribute('href')
      const li = document.querySelector(href)

      if (li) {
        // .is-currentを一旦すべて外す
        document.querySelectorAll('.shop_list > li').forEach((el) => {
          el.classList.remove('is-current')
        })

        // 対象に追加
        li.classList.add('is-current')

        // スクロール実行
        const top = li.getBoundingClientRect().top + window.scrollY - offset
        window.scrollTo({
          top: top,
          behavior: 'smooth',
        })
      }
    })
  })

  const spLinks = document.querySelectorAll('.inner.is-sp a[href^="#open"]')

  spLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault()

      const href = link.getAttribute('href')
      const target = document.querySelector(href)

      if (target) {
        // .is-current をすべて外す
        document.querySelectorAll('.shop_list > li').forEach((li) => {
          li.classList.remove('is-current')
        })

        // 対象の li に .is-current を付与
        target.classList.add('is-current')

        // スムーススクロール
        const top = target.getBoundingClientRect().top + window.scrollY - offset
        window.scrollTo({
          top: top,
          behavior: 'smooth',
        })
      }
    })
  })
})
